/** Minimal renderer for KB markdown: paragraphs + **bold**. */
export function renderKbContent(content) {
  return (content || "").split("\n").map((line, i) => {
    if (!line.trim()) return <br key={i} />;
    const segs = [];
    let last = 0;
    const re = /\*\*(.+?)\*\*/g;
    let m;
    while ((m = re.exec(line)) !== null) {
      if (m.index > last) segs.push(line.slice(last, m.index));
      segs.push(<strong key={`b${i}-${m.index}`}>{m[1]}</strong>);
      last = m.index + m[0].length;
    }
    if (last < line.length) segs.push(line.slice(last));
    return <p key={i} className="text-sm leading-relaxed">{segs.length ? segs : line}</p>;
  });
}
